import { Component, OnInit, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TCCPCommonService } from '../shared/services/tccp-common.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { TCCPLocalStorageService } from '../shared/services/tccp-local-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../shared/components/dialog/dialog.component';
import { User } from '../shared/models/user';
import moment from 'moment';
import * as _ from 'lodash';
import { TCCPConstantValues } from '../shared/models/tccp-constants';
import { BnNgIdleService } from 'bn-ng-idle';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus, EventMessage, AuthenticationResult, EventType } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-lexus-layout',
  templateUrl: './lexus-layout.component.html',
  styleUrls: ['./lexus-layout.component.scss']
})

export class LexusLayoutComponent implements OnInit, OnDestroy {
  public theme = '';
  public showFeedback = false;
  public hideBreadcrumb = false;
  public hideBanner = false;
  public isInternal = false;
  public windowWidth: number = window.innerWidth;
  private readonly _destroying$ = new Subject<void>()
  public loginDisplay = false;
  constructor(
    private msalBroadcastService: MsalBroadcastService,
    public router: Router,
    private renderer: Renderer2, public dialog: MatDialog, private bnIdle: BnNgIdleService, public authService: MsalService,
    private commonService: TCCPCommonService, private storageService: TCCPLocalStorageService, private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {


    this.msalBroadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      this.setLoginDisplay();
      this.checkAndSetActiveAccount();
    })

    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((message: EventMessage) => message.eventType === EventType.LOGIN_SUCCESS),
    )
    .subscribe((message: EventMessage) =>{
      const authResult = message.payload as AuthenticationResult;
      if(authResult !== undefined && authResult !== null){
        var token = JSON.stringify({token:authResult?.idToken})
        this.storageService.setToken(token);
      }
      this.authService.instance.setActiveAccount(authResult.account);
      this.storageService.setUpn(this.authService.instance.getActiveAccount().username);
    })

    this.commonService.landingPage = true;
    this.theme = environment.applicationName;
    this.isInternal = this.commonService.setAppFeatureType(this.router.url);
    if (this.authService.instance.getActiveAccount() && !_.isNil(this.authService.instance.getActiveAccount().username)) {
      const upn = this.authService.instance.getActiveAccount().username;
      this.isTermsAcceptedByUser(upn, this.theme);
    }
    
    this.storageService.setDivision(this.theme);

    this.commonService.hideBreadrumb.subscribe(flag => {
      if (flag) {
        this.hideBreadcrumb = flag;
      } else {
        this.hideBreadcrumb = false;
      }
    });

    this.commonService.hideBanner.subscribe(flag => {
      if (flag) {
        this.hideBanner = flag;
      } else {
        this.hideBanner = false;
      }
    });
  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  ngAfterViewInit() {
    this.commonService.changeLayoutStyle.subscribe((data) => {
      const el = document.querySelector('.content-block');
      const classes = el.getAttribute('class').split(' ');
      classes.forEach((cl) => {
        if (!data) {
          this.renderer.removeClass(el, 'col-sm-12');
          this.renderer.removeClass(el, 'align-self-center');
          this.renderer.addClass(el, 'content-block-height');
          this.renderer.addClass(el, 'col-sm-12');
        } else {
          this.renderer.removeClass(el, 'content-block-height');
          this.renderer.addClass(el, 'col-sm-12');
        }
      });
    },
      (error) => {
      });
  }

  public isTermsAcceptedByUser(upn: string, division: string) {
    let loggedUser: User;
    this.commonService.getUserInfo(upn, division).subscribe(user => {
      loggedUser = user[0];
      if (_.isEmpty(loggedUser)) {
        this.dialog.open(DialogComponent, {
          width: '600px',
          id: this.theme + '-agree-popup'
        });
      } else {
        const lastVisited = loggedUser.visitedAt;
        const duration = moment.duration(moment().diff(lastVisited));
        const hours: number = duration.asHours();
        if (Math.trunc(hours) > TCCPConstantValues.lexus.FIXED_VALUES.INTERVAL) {
          this.dialog.open(DialogComponent, {
            width: '600px',
            id: this.theme + '-agree-popup'
          });
        }
      }
    });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    if(activeAccount){
      this.storageService.setUpn(this.authService.instance.getActiveAccount().username);
    }

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
      this.storageService.setUpn(this.authService.instance.getActiveAccount().username);
    }
  }

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();

  }

}
